import * as React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline';
  children: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'default', className = '', children, ...props }, ref) => {
    const baseClasses = 'px-4 py-2 rounded font-medium transition-colors inline-flex items-center justify-center whitespace-nowrap';
    const variantClasses = variant === 'outline' 
      ? 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
      : 'bg-adv-orange text-white hover:bg-adv-orange/90';
    
    return (
      <button 
        ref={ref}
        className={`${baseClasses} ${variantClasses} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button'; 